"use client";

import React from "react";
import { Search, FileText, Settings, Droplet } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const steps = [{
  title: "Patient Scheduling",
  description: "Our front-desk support initiates the cycle with rigorous insurance verification and accurate data capture to prevent upstream claim denials.",
  icon: Search
}, {
  title: "Medical Coding",
  description: "Certified experts translate clinical encounters into precise ICD-10 and CPT codes, ensuring absolute compliance and maximum revenue capture.",
  icon: FileText
}, {
  title: "Claims Submission",
  description: "Leveraging advanced scrubbing technology, we submit clean claims electronically to payers, minimizing administrative friction and accelerating processing.",
  icon: Settings
}, {
  title: "Final Reimbursement",
  description: "Proactive denial management and precise payment posting optimize your cash flow, ensuring you receive full value for every patient service.",
  icon: Droplet
}];
export default function TheProFlowProcess() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="127467" id="the-revenue-cycle-lifecycle" className="bg-background py-24 overflow-hidden text-foreground">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {}
        <div className="text-center max-w-3xl mx-auto mb-20">
          <h2 className="text-3xl md:text-5xl font-bold text-primary tracking-tighter mb-4 font-default">
            The Revenue Cycle Lifecycle
          </h2>
          <p className="text-lg text-muted-foreground font-sans">
            A high-velocity, precision-engineered approach to medical billing. We manage every financial touchpoint to ensure your practice maintains optimal fiscal health.
          </p>
        </div>

        {}
        <div ref={ref} className="relative">
          
          {}
          <div className="hidden md:block absolute top-8 left-[10%] right-[10%] h-1 border-t-2 border-dashed border-primary/20 -translate-y-1/2 z-0" />
          
          {}
          <div className="hidden md:block absolute top-8 left-[10%] h-1 bg-ring shadow-[0_0_15px_rgba(49,196,243,0.5)] -translate-y-1/2 z-0 transition-all duration-1500 ease-in-out" style={{
          width: isVisible ? '80%' : '0%'
        }} />

          {}
          <div className="md:hidden absolute top-8 bottom-8 left-8 w-1 border-l-2 border-dashed border-primary/20 -translate-x-1/2 z-0" />
          
          {}
          <div className="md:hidden absolute top-8 left-8 w-1 bg-ring shadow-[0_0_15px_rgba(49,196,243,0.5)] -translate-x-1/2 z-0 transition-all duration-1500 ease-in-out" style={{
          height: isVisible ? 'calc(100% - 4rem)' : '0%'
        }} />

          {}
          <div className="relative z-10 grid grid-cols-1 md:grid-cols-4 gap-12 md:gap-6">
            {steps.map((step, i) => <div key={i} data-index={i} className="relative flex flex-row md:flex-col items-start md:items-center gap-6 md:gap-8">
                {}
                <div className={cn("flex-shrink-0 flex items-center justify-center w-16 h-16 rounded-full border-4 border-background bg-primary text-primary-foreground shadow-xl transition-all duration-700 ease-out", isVisible ? "opacity-100 scale-100" : "opacity-0 scale-50")} style={{
              transitionDelay: `${i * 300}ms`
            }}>
                  <step.icon className="w-6 h-6" />
                </div>

                {}
                <Card className={cn("flex-1 md:w-full bg-card/60 backdrop-blur-md border-border/50 shadow-sm hover:shadow-xl hover:border-ring/30 transition-all duration-700 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")} style={{
              transitionDelay: `${i * 300 + 150}ms`
            }}>
                  <CardHeader className="pb-2">
                    <div className="text-xs font-bold text-ring mb-1 tracking-widest uppercase font-mono">
                      Phase 0{i + 1}
                    </div>
                    <CardTitle className="text-xl text-primary font-default">
                      {step.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <CardDescription className="text-base text-muted-foreground leading-relaxed font-sans">
                      {step.description}
                    </CardDescription>
                  </CardContent>
                </Card>
              </div>)}
          </div>
        </div>

      </div>
    </section>;
}